import React from 'react';

const NotFound: React.FC = () => {

    window.location.href = window.location.origin + '/v1/home?url=404';

    return (<div></div>)
}

export default NotFound;